{
  "landingV2": {
    "hero": {
      "overline": "Live-сессии • события • сообщество",
      "titleLine1": "Любовь как действие.",
      "titleLine2Prefix": "Практика как",
      "titleAccent": "путь.",
      "description1": "Agapella объединяет мастеров, духовные центры и людей-исследователей вокруг любви как созидательной силы.",
      "description2": "Через живые практики, события, знания и человеческие связи мы создаём пространство, где каждый может раскрывать свой потенциал и двигаться по собственному пути развития.",
      "actions": {
        "startPractice": "Начать практику",
        "viewCalendar": "Посмотреть календарь"
      }
    },
    "about": {
      "overline": "Кто мы",
      "title": "Пространство для практики, обучения и общения",
      "p1": "Мы — мультикультурная команда исследователей, сотворцов и архитекторов поддерживающей среды.",
      "p2": "Название Agapella происходит от древнегреческого слова Agape — любви как действия во благо другого человека.",
      "p3": "Мы создаём международную платформу, объединяющую людей разных культур, традиций и взглядов вокруг осознанности, уважения и совместного развития.",
      "p4": "Наша цель — сделать глубокие практики, живое общение и поддержку единомышленников доступными каждому независимо от страны проживания и уровня подготовки."
    },
    "platform": {
      "overline": "Платформа",
      "title": "Всё необходимое для регулярной практики",
      "subtitle": "Живые встречи, знания, мастера и пространство для осознанного развития в одном месте.",
      "cards": {
        "livePractices": {
          "title": "Живые практики",
          "desc": "Участвуйте в медитациях, дыхательных практиках и других живых сессиях вместе с мастерами и участниками со всего мира."
        },
        "masters": {
          "title": "Мастера и эксперты",
          "desc": "Находите проводников разных традиций и направлений, знакомьтесь с их опытом и выбирайте тех, кто откликается именно вам."
        },
        "quickRooms": {
          "title": "Быстрые Live-сессии",
          "desc": "Создавайте собственные пространства для общения, совместных практик и встреч с единомышленниками."
        },
        "calendar": {
          "title": "Единый календарь",
          "desc": "Следите за всеми активностями платформы через единое расписание практик, событий и встреч."
        }
      }
    },
    "steps": {
      "overline": "Как начать",
      "title": "Ваш путь начинается здесь",
      "items": {
        "createAccount": {
          "title": "Создайте аккаунт",
          "desc": "Регистрация занимает меньше минуты и открывает доступ ко всем возможностям платформы."
        },
        "findDirection": {
          "title": "Найдите интересующее направление",
          "desc": "Исследуйте практики, события и мастеров по темам, которые вам близки."
        },
        "joinPractice": {
          "title": "Присоединитесь к практике",
          "desc": "Участвуйте в живых встречах или изучайте материалы в удобное время."
        },
        "practiceRegularly": {
          "title": "Практикуйте регулярно",
          "desc": "Выстраивайте собственный ритм, возвращайтесь к практикам и развивайтесь через живое участие."
        }
      }
    },
    "why": {
      "overline": "Почему Agapella",
      "title": "Не просто контент. Живой опыт.",
      "cards": {
        "realtimePractice": {
          "title": "Практика в реальном времени",
          "desc": "Agapella строится вокруг живого взаимодействия между людьми. Здесь практика происходит не в записи, а рядом с теми, кто идёт похожим путём."
        },
        "ownPace": {
          "title": "Развитие в собственном темпе",
          "desc": "Выбирайте практики и встречи, которые соответствуют вашему состоянию сегодня и жизненному этапу."
        },
        "peopleEvents": {
          "title": "Люди и события",
          "desc": "Находите единомышленников, участвуйте в совместных инициативах и становитесь частью международного сообщества осознанных людей."
        }
      }
    }
  },
  "footerV2": {
    "description1": "Agapella — международная live‑платформа и живое сообщество, объединяющее людей вокруг любви как созидательной силы.",
    "description2": "Мы создаём пространство, где практики, знания, поддержка и человеческие связи помогают раскрывать потенциал и создавать новое вместе.",
    "tagline": "Agapella. От сердца к сердцу.",
    "groups": {
      "navigation": "Навигация",
      "platform": "О платформе",
      "legal": "Правовая информация"
    },
    "links": {
      "practices": "Практики",
      "calendar": "Календарь",
      "masters": "Мастера",
      "quickRooms": "Быстрые Live-сессии",
      "about": "О нас",
      "privacyPolicy": "Политика конфиденциальности",
      "cookieSettings": "Настройки cookie",
      "termsOfService": "Пользовательское соглашение",
      "streamingAgreement": "Соглашение о стриминге"
    }
  },
  "theme": {
    "mode": "{{mode}} режим"
  }
}
